import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "research" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ReasoningItem = _resolveComponent("ReasoningItem")
  const _component_ScrollBar = _resolveComponent("ScrollBar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ScrollBar, {
      ref: "scroller",
      "max-height": "36rem",
      class: _normalizeClass(["scroller", {top: $data.top, bottom: $data.bottom}]),
      relative: "",
      onScroll: $options.checkScrollPosition
    }, {
      default: _withCtx(() => [
        _createVNode(_TransitionGroup, {
          name: "list",
          css: !$props.completed,
          onAfterEnter: $options.afterEnter
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, ind) => {
              return (_openBlock(), _createBlock(_component_ReasoningItem, {
                key: ind,
                class: "item",
                item: item,
                last: ind === $data.items.length - 1,
                completed: $props.completed
              }, null, 8 /* PROPS */, ["item", "last", "completed"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["css", "onAfterEnter"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "onScroll"])
  ]))
}